/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { QueueMessagesWebNewTask } from '../models/QueueMessagesWebNewTask';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class QueuesApiService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Enqueues a task
     * @param requestBody
     * @returns string OK
     * @throws ApiError
     */
    public postQueuesApiEnqueueTask(
        requestBody?: QueueMessagesWebNewTask,
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/queues/enqueueTask',
            body: requestBody,
            mediaType: 'application/json-patch+json',
        });
    }

    /**
     * Checks the status of a task
     * @param qName
     * @returns string OK
     * @throws ApiError
     */
    public getQueuesApiCheckQueue(
        qName?: string,
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/queues/checkTask',
            query: {
                'qName': qName,
            },
        });
    }

}
